// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OperacaoCompromissos_CardsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /dashboards/operacao_compromissos/cards.
 *
 * Returns aggregate counts and value totals for compromissos in the
 * filtered scope, broken down by status (realizados / agendados /
 * cancelados).
 *
 * Value totals are summed from compromissos.compromisso_total which is
 * stored as a string-of-reais in MySQL (e.g. '470' = R$470). The model
 * casts to float at the SUM level and the controller assigns directly.
 *
 * Counts are integers (COUNT(*)).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface OperacaoCompromissos_CardsResponseDados {
realizados_qtd: number
realizados_valor: number
agendados_qtd: number
agendados_valor: number
cancelados_qtd: number
cancelados_valor: number
}

export type OperacaoCompromissos_CardsResponse = ApiResponse<OperacaoCompromissos_CardsResponseDados>;

registerResponseContract('OperacaoCompromissos_CardsResponse', {
  realizados_qtd:   { type: 'number',  required: true },
  realizados_valor: { type: 'number',  required: true },
  agendados_qtd:    { type: 'number',  required: true },
  agendados_valor:  { type: 'number',  required: true },
  cancelados_qtd:   { type: 'number',  required: true },
  cancelados_valor: { type: 'number',  required: true },
})
